
import { defineComponent } from "vue";
import { usePickingStore } from "@/stores/ssaStore/picking";
import { storeToRefs } from "pinia";
export default defineComponent({
	name: "ImdexPickTable",
	mounted() {
		console.log("dfsdsffds");
	},
	setup() {
		const pickStore = usePickingStore();
		const { SSA_PICK_DATA_STORE: pickDataStore } = storeToRefs(usePickingStore());
		return {
			pickStore,
			pickDataStore
		};
	},
	data() {
		return {
			selectAllFiles: false
		};
	},
	methods: {
		selectRow() {
			console.log("row");
			this.$nextTick(() => {
				console.log("su");
			});
		},
		clearPickDataStore(): any {
			this.pickStore.SSA_PICK_DATA_STORE_SET([]);
		}
	},
	computed: {
		tableData(): any {
			return {
				columns: this.tableDataColumns,
				options: this.tableDataOptions,
				tableData: this.pickDataStore.map((item: any) => ({
					...item,
					select: false,
					delete: false
				}))
			};
		},
		tableDataOptions(): any {
			const cols = this.tableDataColumns.map(() => {
				return {
					filterable: true,
					sortable: true,
					searchable: true
				};
			});
			const obj: any = {};
			for (let i = 0; i < cols.length; i++) {
				obj[this.tableDataColumns[i]] = cols[i];
			}
			return {
				thead: {
					background: "#E6E8E9"
				},
				rows: {
					spacing: "5px"
				},
				perPage: 100,
				columns: {
					...obj,
					select: {
						maxWidth: "2%",
						filterable: false,
						sortable: false
					},
					delete: {
						maxWidth: "5%",
						filterable: false,
						sortable: false
					}
				}
			};
		},
		tableDataColumns(): any {
			const columns: any = [];
			for (let i = 0; i < this.pickDataStore.length; i++) {
				const keys = Object.keys(this.pickDataStore[i]);
				for (let k = 0; k < keys.length; k++) {
					if (columns.indexOf(keys[k]) == -1) {
						columns.push(keys[k]);
					}
				}
			}

			return columns.length ? ["select", ...columns, "delete"] : [];
		}
	},
	watch: {
		tableData: {
			deep: true,
			handler(v) {
				console.log(v);
			}
		},
		selectAllFiles() {
			//console.log(v);
		}
	}
});
